import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import logo from "./assets/itiniri_app_logo.png";
import lightLogo from "./assets/itiniri_logo_light.png";
import shadowLogo from "./assets/itiniri_shadow.png";
import Support from "./Pages/Support";
import Privacy from "./Pages/Privacy";
import Demo from "./Pages/Demo";
import Calculator from "./components/Calculator";
import ArtistInstructions from "./Pages/FAQ_pages/ArtistInstructions";
import VendorInstructions from "./Pages/FAQ_pages/VendorInstructions";
import GatheringInstructions from "./Pages/FAQ_pages/GatheringInstructions";
import ReferralInstructions from "./Pages/FAQ_pages/ReferralInstructions";
import FAQ from "./Pages/FAQ";

import screenshot1 from "./assets/home-screen.png";
import screenshot2 from "./assets/schedule.png";
import screenshot3 from "./assets/map.png";
import screenshot4 from "./assets/vendor.png";

function Home() {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <div id="hero-content" className="hero-content">
        <div className="hero-title-wrapper">
          <h1 className="main-title">
            Empower your event with <br />
            <img
              src={shadowLogo}
              alt="Itiniri Light Logo"
              className="hero-logo"
            />
          </h1>
        </div>
        <p className="sub-title">Planning. Sharing. Simplified.</p>
        <div className="cta-buttons">
          <a
            href="https://itiniri.app/auth"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="button get-started">Get Started</button>
          </a>
          <h4 id="or">OR</h4>
          <button
            className="button view-demo body-demo"
            onClick={() => navigate("/demo")}
          >
            View Demo
          </button>
        </div>
      </div>

      <div id="intro-container" className="intro-container">
        <h2>Welcome to your best event yet</h2>
        <p>
          We exist to make it simple and affordable to communicate information
          to your event's attendees. Our simple online site allows you and your
          team to upload and manage all your information, which your attendees
          can easily access through our app. Get started today, either by
          clicking the button above or contacting us directly.
          <br />
          <br />
          Sincerely,
          <br />
          Will and Albie, Founders of itiniri
        </p>
      </div>

      <div id="steps-container" className="steps-container">
        <div className="step">
          <h3>Save Time</h3>
          <p>Program, planning, and updates—all in one easy-to-use platform.</p>
        </div>
        <div className="step">
          <h3>Save Money</h3>
          <p>
            Itiniri costs less than printed programs and other digital tools.
          </p>
        </div>
        <div className="step">
          <h3>Easy Sharing</h3>
          <p>Share event details instantly with attendees.</p>
        </div>
      </div>

      <div className="screenshots">
        <div className="screenshots-grid">
          <img src={screenshot1} alt="Itiniri screenshot 1" className="screenshot-item" />
          <img src={screenshot2} alt="Itiniri screenshot 2" className="screenshot-item" />
          <img src={screenshot3} alt="Itiniri screenshot 3" className="screenshot-item" />
          <img src={screenshot4} alt="Itiniri screenshot 4" className="screenshot-item" />
        </div>
      </div>

      <div id="calculator-section">
        <Calculator />
      </div>
    </section>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <header id="header" className="header">
          <a href="/">
            <img src={logo} alt="Itiniri Logo" className="logo-image" />
          </a>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              className="button header-demo-btn"
              onClick={() => (window.location.href = "/faq")}
            >
              FAQ
            </button>
            <button
              className="button header-demo-btn"
              onClick={() => (window.location.href = "/demo")}
            >
              View Demo
            </button>
            <a
              href="https://itiniri.app/auth"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="button get-started">Get Started</button>
            </a>
          </div>
        </header>

        <div className="content-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/support" element={<Support />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/faq/vendors" element={<VendorInstructions />} />
            <Route path="/faq/artists" element={<ArtistInstructions />} />
            <Route path="/faq/events" element={<GatheringInstructions />} />
            <Route path="/faq/referral" element={<ReferralInstructions />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>

          <footer className="footer">
            <div className="footer-links">
              <a href="/support" className="footer-link">
                Support
              </a>
              <a href="/privacy" className="footer-link">
                Privacy
              </a>
              <a href="/demo" className="footer-link">
                Demo
              </a>
            </div>
            <div className="copyright">
              © 2024 Itiniri | All rights reserved
            </div>
          </footer>
        </div>
      </div>
    </Router>
  );
}

export default App;
